module.exports = __webpack_public_path__ + "img/avatar.71dc1238.jpg";